import React from 'react';

const Abandoned = () => {
  return <div>Abandoned</div>;
};

export default Abandoned;
